import { GeneralDistricts } from 'types/districts';
import api from './apis/api';

export const getOperationDistricts = () => api.get<GeneralDistricts>('/districts/operation');
